import { background } from '@lib/style/mixins/background';
import { position } from '@lib/style/mixins/position';
import React from 'react';
import styled from 'styled-components';

const DisableCoverComponent = ({ children, show, component = 'div', ...props }) => {
    if (!show) {
        return null;
    }

    const Component: any = component;

    background.clean(props);
    position.clean(props);

    return <Component {...props}>{children}</Component>;
};

export const DisableCover = styled(DisableCoverComponent)`
    & {
        cursor: not-allowed;
        ${position('absolute', [0, 0, 0, 0], 9999)};
        background-color: transparent;
        will-change: background-color;
        transition: background-color 500ms ease-in;
        &:hover {
            ${background('rgba(0,0,0,.1)')}
        }
    }
`;
